import { ProductType } from '../enums';

export type ProductTypeUrlSuffixPluralIndex = 'families' | 'groups' | 'products';

export const ProductTypeUrlSuffixPlural: Record<ProductType, ProductTypeUrlSuffixPluralIndex> = {
  [ProductType.Family]: 'families',
  [ProductType.Group]: 'groups',
  [ProductType.Product]: 'products',
};
